import { Component, OnInit } from '@angular/core';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-footer-adverts',
  templateUrl: './footer-adverts.component.html',
  styleUrls: ['./footer-adverts.component.scss']
})

export class FooterAdvertsComponent implements OnInit {
  public timeZone=null;
  // TimeZone related configuration
  public DefaultTimeZone:boolean = true;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public USATimeZone:boolean = false;

  constructor(private timezoneService: TimeZoneService) {

  }

  ngOnInit() {
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
  }
}
